import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { metaTagsData } from './meta-tags-data';

@Injectable()
export class MetaDataService {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private title: Title,
    private meta: Meta,
    // TODO исправить ошибку NullInjectorError: No provider for Renderer2
    private rendererFactory: RendererFactory2,
  ) {}

  public setMetaTags(urlAfterRedirects: /* keyof typeof metaTagsData*/ string) {
    const currentRoute = urlAfterRedirects
      ?.split('?')?.[0]
      ?.replace(/\d+/g, 'id');
    const url = this.document.location.origin + this.document.location.pathname;
    const { title, description, image } = metaTagsData[currentRoute] || {};
    const renderer = this.rendererFactory.createRenderer(null, null);

    // устанавливаем тег <title>
    this.title.setTitle(title || '');

    // устанавливаем теги <meta>
    const tags = [
      { title: 'title', data: title },
      { title: 'description', data: description },
    ];
    tags.forEach(({ title, data }) => {
      this.changeMetaTag(title, data);
    });

    // устанавливаем open-graph теги вида <meta property="og:some_tag">
    const ogTags = [
      { title: 'og:title', data: title },
      { title: 'og:description', data: description },
      { title: 'og:image', data: image },
      { title: 'og:url', data: url },
    ];
    ogTags.forEach(({ title, data }) => {
      this.changeOpenGraphMetaTag(title, data);
    });

    // устанавливаем тег <link rel="canonical">
    const links = [
      { title: 'canonical', data: url },
      { title: 'icon', data: image },
    ];
    links.forEach(({ title, data }) => {
      this.updateLinkTag(title, data, renderer);
    });
  }

  private changeMetaTag(name: string, content: string) {
    if (content?.length) {
      if (this.meta.getTag(`name="${name}"`)) {
        this.meta.updateTag({ name, content });
      } else {
        this.meta.addTag({ name, content });
      }
    } else {
      this.meta.removeTag(`name="${name}"`);
    }
  }

  private changeOpenGraphMetaTag(property: string, content: string) {
    if (content?.length) {
      if (this.meta.getTag(`property="${ property }"`)) {
        this.meta.updateTag({ property, content });
      } else {
        this.meta.addTag({ property, content });
      }
    } else {
      this.meta.removeTag(`property="${ property }"`);
    }
  }

  public updateTitleAfterDataLoading(
    currentRoute: /* keyof typeof metaTagsData,*/ string,
    datasetName?: string,
    datasetDescription?: string,
    skipUpdateImage = false,
  ) {
    const { title, description, image } = metaTagsData[currentRoute] || {};
    const url = this.document.location.origin + this.document.location.pathname;

    if (datasetName) {
      this.title.setTitle(`${ datasetName } | ${ title ?? '' }`);
      this.meta.updateTag({ name: 'title', content: `${ datasetName }${ title ? (' | ' + title) : '' }` });
      this.meta.updateTag({ property: 'og:title', content: `${ datasetName }${ title ? (' | ' + title) : '' }` });
    }

    if (datasetDescription) {
      this.changeMetaTag('description', `${ datasetDescription }${ description ? (' | ' + description) : '' }`);
      this.changeOpenGraphMetaTag('og:description', `${ datasetDescription }${ description ? (' | ' + description) : '' }`);
    }

    if (skipUpdateImage) {
      this.meta.updateTag({ property: 'og:image', content: image });
      this.meta.updateTag({ property: 'og:url', content: url });
    }
  }

  private updateLinkTag(rel: string, linkValue: string, renderer: Renderer2) {
    const link = this.document.querySelector(`link[rel="${ rel }"]`);
    if (link) {
      renderer.setAttribute(link, 'href', linkValue);
    } else {
      const link: HTMLLinkElement = renderer.createElement('link');
      renderer.setAttribute(link, 'rel', rel);
      renderer.setAttribute(link, 'href', linkValue);
      renderer.appendChild(this.document.head, link);
    }
  }
}
